import AddFundsPage from './AddFundsPage';

export default AddFundsPage;
